import React from 'react'
import { Row, Col } from "react-bootstrap";
import { checkArray } from '../helpers/util';
import { inscriptionHeading } from '../helpers/inscriptionUtils';

export default class DetailElementZitate extends React.Component {
	
  	render() {
		const inschriften = this.props.inschriften || [];
    	return (<div>
	        {checkArray(this.props.value) ? 
      			<Row >
					<Col md={3} style={{backgroundColor: '#ffffff'}}>
						<strong>{this.props.name}</strong>
       				</Col>
					<Col  md="auto" style={{backgroundColor: '#ffffff'}}></Col>
					<Col md={{ span: 10, offset: 1 }} style={{backgroundColor: '#fbfbfb'}}>
						{this.props.value.map((zitat, id) => {
							const block = inschriften.find(entry => entry && entry.id === zitat.inschriftId);
							const location = block ? inscriptionHeading(block) : "";
							return (<div key={id}>{location ? location + ", " : ""}Zeile {zitat.zeile}: {zitat.quelle}</div>);
						})}
       				</Col>
      		</Row>
			: ""}</div>
			
    )
  }
}
